import React from "react";
import PulseMinibrew from "@common/components/PulseMinibrew/PulseMinibrew";

const ConnectionLostOverlay = () => {
  return (
    <div
      style={{
        top: "0",
        left: "0",
        position: "absolute",
        color: "white",
        backgroundColor: "rgba(29, 34, 40,  0.9)",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        borderRadius: "3px",
        // Informational only: it must not swallow clicks. It spans the whole
        // panel, which includes the user-action bar's Go button, so without this
        // a device that stops streaming frequent logs locks the user out of
        // acknowledging the very user action that is blocking the machine --
        // exactly when they need it (e.g. parked at CIP-done on a flaky link).
        pointerEvents: "none",
      }}
    >
      <PulseMinibrew />
      <div>Connection lost, reconnecting...</div>
    </div>
  );
};

export default ConnectionLostOverlay;
